import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import { useTranslation, Trans } from 'react-i18next';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Close from '@material-ui/icons/Close';
import { useTheme, withStyles } from '@material-ui/styles';
import { Typography, Box, Grid, useMediaQuery } from '@material-ui/core';

import { Button } from '@lc/legacy/src/Components';

import { useUserInfo } from '@lc/lib/Provider';

import { useSnackbar } from 'contexts';
import { gtag, booking, url } from 'helpers';

import Link from 'components/Link';
import ViewDetail from 'components/Booking/ViewDetail';
import EPeriodType from '@lc/legacy/src/enum/EPeriodType';

import BookingSummary from './BookingSummary';
import CouponModal from './CouponModal';

const LoginToContinue = ({ data }) => {
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingRegister, setLoadingRegister] = useState(false);
  const theme = useTheme();
  const xsSize = useMediaQuery(theme.breakpoints.down('xs'));

  const equipment = url.getFromQueryString('type') === 'equipment'

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: '#34BA92',
        padding: '150px 30px 30px',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 4000,
        textAlign: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <img
        style={{
          position: 'absolute',
          top: 0,
          left: '0',
          bottom: '0',
          opacity: 0.15,
          width: '100%',
          height: '100%',
        }}
        src="/images/background_letclinic_logo.png"
        alt="background"
      />
      <Typography style={{ color: '#ffffff' }}>
        <b>Para continuar você precisa fazer login</b>
      </Typography>
      <div style={{ width: xsSize ? '100%' : '300px', margin: '0 auto' }}>
        <div style={{ marginTop: '40px' }}>
          <Button
            id="btn-redirect-to-login"
            size="small"
            color="secondary"
            loadingColor="secondary"
            fullWidth
            loading={loadingLogin}
            onClick={() => {
              setLoadingLogin(true);
              Router.push(`/login?returnUrl=/booking/payment/${data.id}${equipment ? '?type=equipment' : ''}`);
            }}
            style={{ backgroundColor: '#ffffff', fontWeight: 'bold' }}
          >
            Já tenho conta
          </Button>
        </div>
        <div style={{ marginTop: '20px' }}>
          <Button
            id="btn-redirect-to-signup"
            size="small"
            color="secondary"
            loadingColor="secondary"
            fullWidth
            loading={loadingRegister}
            onClick={() => {
              setLoadingRegister(true);
              Router.push(`/login?returnUrl=/booking/payment/${data.id}${equipment ? '?type=equipment' : ''}&quickRegister=1`);
              gtag.noAccountQuickRegister();
            }}
            style={{ backgroundColor: '#ffffff', fontWeight: 'bold' }}
          >
            Não tenho conta
          </Button>
        </div>
      </div>
    </div>
  );
};
LoginToContinue.propTypes = {
  data: PropTypes.object.isRequired,
};

const BookingFinish = ({ classes, data, setShowMyPeriodsFinish }) => {
  const { t } = useTranslation(['booking', 'common']);
  const [, setMessage] = useSnackbar();
  const [viewDetail, setViewDetail] = useState();
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loginToContinuer, setLoginToContinue] = useState(false);
  const { isLogged } = useUserInfo();
  const [showCouponModal, setshowCouponModal] = useState(false);
  const [coupon, setCoupon] = useState(booking.getCoupon());
  const [minPeriods, setMinPeriods] = useState(false);
  const periods = Object.values(booking.getPeriods(data.id)).reduce(
    (acc, day) => acc + day.length,
    0,
  );

  const equipment = url.getFromQueryString('type') === 'equipment';

  useEffect(() => {
    if (data.period_type === EPeriodType.HOURS && periods < data.min_hours) {
      setMinPeriods(false);
      window.location.replace(`/booking/${data.id}?openCalendar=1`);
    } else {
      setMinPeriods(true);
    }
  }, []);

  const submit = () => {
    gtag.agreeAndBook();

    if (!isLogged) {
      setLoginToContinue(true);
    } else {
      Router.push(`/booking/payment/${data.id}${equipment ? '?type=equipment' : ''}`);
    }
  };

  const removeCoupon = () => {
    setCoupon(booking.removeCoupon());
    setMessage({ message: 'Cupom removido', variant: 'warning' });
  };

  const onClose = ref => {
    setshowCouponModal(false);
    if (ref) {
      setCoupon(ref);
      booking.setCoupon(ref);
    }
  };

  return (
    <>
      {showCouponModal && <CouponModal roomId={data.id} onClose={onClose} />}
      {loginToContinuer && <LoginToContinue data={data} />}
      {viewDetail && <ViewDetail detail={viewDetail} close={() => setViewDetail(undefined)} />}
      {!loginToContinuer && minPeriods && (
        <>
          <Typography variant="body2" color="textPrimary" style={{ marginTop: '25px' }}>
            <b>{t('beforeFinishCheck')}</b>
          </Typography>

          <Box
            className={classes.border}
            style={{
              marginTop: '25px',
              borderTop: '0.5px solid #A6A6A65E',
              borderBottom: '0.5px solid #A6A6A65E',
            }}
            onClick={() => {
              setShowMyPeriodsFinish(true);
            }}
          >
            <Typography variant="body2" color="secondary">
              <b>Minhas seleções</b>
            </Typography>
            <ChevronRightIcon />
          </Box>
          <Box
            className={classes.border}
            style={{
              borderBottom: '0.5px solid #A6A6A65E',
            }}
            onClick={() =>
              setViewDetail({
                title: data.title,
                content: <Typography style={{ marginTop: '12px' }}>{data.description}</Typography>,
              })
            }
          >
            <Typography variant="body2" color="secondary">
              <b>
                {data.clinic !== 'Equipamento' ? t('clinic') + ' ' + data.clinic : data.clinic}
              </b>
            </Typography>
            <ChevronRightIcon />
          </Box>
          <div style={{ marginTop: '20px' }}>
            <BookingSummary data={data} coupon={coupon} />
          </div>

          {coupon ? (
            <Box
              className={classes.border}
              style={{
                marginTop: '25px',
                borderTop: '0.5px solid #A6A6A65E',
                borderBottom: '0.5px solid #A6A6A65E',
                cursor: 'pointer',
                alignItems: 'center',
              }}
              onClick={() => removeCoupon()}
            >
              <Typography variant="body2" color="secondary">
                <b style={{ fontSize: '12px', color: '#3a3a3a', fontWeight: '600' }}>
                  Remover cupom
                </b>
              </Typography>
              <Close style={{ fontSize: '19px', color: '#ff6f6f' }} />
            </Box>
          ) : (
            <Box
              className={classes.border}
              style={{
                marginTop: '25px',
                borderTop: '0.5px solid #A6A6A65E',
                borderBottom: '0.5px solid #A6A6A65E',
                cursor: 'pointer',
                alignItems: 'center',
              }}
              onClick={() => setshowCouponModal(true)}
            >
              <Typography variant="body2" color="secondary">
                <b style={{ fontSize: '12px', color: '#3a3a3a', fontWeight: '600' }}>
                  Insira um cupom
                </b>
              </Typography>
              <ChevronRightIcon />
            </Box>
          )}

          <div style={{ marginTop: '20px' }}>
            <Typography
              color="textPrimary"
              style={{ marginTop: '15px' }}
              className={classes.cancelPolicy}
            >
              <b>{t('cancelPolicy')}</b>
            </Typography>
            <Typography color="textPrimary" className={classes.cancelPolicy}>
              {data.clinic !== 'Equipamento' ? <Trans
                t={t}
                i18nKey={
                  data.period_type === EPeriodType.HOURS
                    ? 'cancelPolicyByHoursDescriptionWithLink'
                    : 'cancelPolicyDescriptionWithLink'
                }
              >
                <Link
                  href="/terms/terms-of-service"
                  className={classes.linkDialog}
                  target="_blank"
                  color="secondary"
                >
                  first node
                </Link>
              </Trans> : <Trans
                t={t}
                i18nKey={'cancelPolicyEquipmentDescription'}
              >
                <Link
                  href="/terms/terms-of-service"
                  className={classes.linkDialog}
                  target="_blank"
                  color="secondary"
                >
                  first node
                </Link>
              </Trans>}
            </Typography>
          </div>
          <Grid container spacing={0} justify="center" style={{ marginTop: '28px' }}>
            <div style={{ textAlign: 'center' }}>
              <Button
                id={equipment ? 'btn-agree-and-book-equipment' : 'btn-agree-and-book'}
                variant="contained"
                color="secondary"
                size="small"
                loadingColor="secondary"
                loading={loadingBtn}
                onClick={() => {
                  setLoadingBtn(true);
                  submit();
                }}
              >
                {t('agreeAndBook')}
              </Button>
              <Typography color="textPrimary" className={classes.cancelPolicy}>
                Você ainda não será cobrado.
              </Typography>
            </div>
          </Grid>
        </>
      )}
    </>
  );
};

BookingFinish.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  setShowMyPeriodsFinish: PropTypes.func.isRequired,
};

const styles = () => ({
  cancelPolicy: {
    fontSize: '10px',
  },
  border: {
    padding: '8px 10px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export default withStyles(styles)(BookingFinish);
